
import { CommonDialog, ProfileDropdown, TitleAndEdit } from '../../../Common/CommonComponents'
import AppSvc from '../../../../services/app-svc'
import ProfileSvc from '../../../../services/profile-svc';
import { TheCode, ThePassword } from '../../../Common/CommonSteps'
import ChangePasswordStep from './components/ChangePasswordStep.vue'

let profileSvc = null;
let service = null;

import User from '../../../../models/User';

export default {
    components: { CommonDialog, ProfileDropdown, TitleAndEdit, TheCode, ThePassword, ChangePasswordStep },
    props: {
        user: {
            required: true,
            default: null,
            type: Object
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
    },
    data() {
        return {
            showDialog: false,
            showGdprDialog: false,
            gdprRedirectUrl: '',
            edit: false,
            hasChanged: false,
            modifiedUser: {...this.user},
            validated: false,
            rules: {
                required: value => !!value || 'Dette feltet er obligatorisk.',
                containsCharacter: value => value.replace(/\s/g, '').length || 'Må inneholde tegn',
                name: value => {
                    const pattern = /^[a-zA-Z\Wæøå]*$/
                    return pattern.test(value) || 'Navn kan ikke inneholde tall eller spesialtegn.'
                },
                mobile: value => {
                    const pattern = /^[0-9]{8}$/
                    return pattern.test(value) || 'Mobilnummer må være 8 siffer.'
                },
                optionalPhone: value => {
                    const pattern = /^[0-9]{8}$/
                    return (pattern.test(value) || value.length == 0) || 'Telefonnummer må være 8 siffer.'
                },
                postalCode: value => {
                    const pattern = /^[0-9]{4}$/

                    return (pattern.test(value) || value.length == 0 || this.invalidPostalCode) || this.invalidPostalCode ? 'Ugyldig postnummer' : 'Postnummer må være 4 siffer.'
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    const unspportedDomains = ['yourwish.no']
                    const illegalDomain = unspportedDomains.includes(value.split('@')[1])
                    return pattern.test(value) && !illegalDomain || (illegalDomain ? 'Dette domenet kan ikke brukes.' : 'Ugyldig e-postaddresse.')
                },
                changeEmailError: () => {
                    return !this.emailError || 'Denne e-post addressen er allerede i bruk.'
                },
                changeMobileError: () => {
                    return !this.mobileError || 'Dette mobilnummeret er allerede i bruk.'
                }
            },

            showOTCdialog: false,
            showResendText:false,
            state: {
                EMAILCODE: 'verify-email',
                SMSCODE: 'verify-sms'
            },
            passwordStates: {
                RESET_PASSWORD: 'reset-password',
                FORGOT_PASSWORD: 'forgot-password',
                VERIFY_EMAIL: 'password-verify-email',
                NEW_PASSWORD: 'new-password'
            },

            showMobileMessage: false,
            showEmailMessage: false,
            mobileError: false,
            emailError: false,
            currentForm: '',
            requiredActions: [],
            code: '',
            error: '',
            loading: false,

            clientIdentity: null,
            emailTicket: null,
            mobileTicket: null,

            modifiedPostalCode: this.user.postalCode,
            invalidPostalCode: false,

            currentChangePasswordForm: '',
            oldPassword: '',
            newPassword: '',
        }
    },
    computed: {
        isTpn() {
			return !!this.tpnChainId
		},
		tpnChainId() {
            /**
             * Webshop TPN or Homepages TPN
             */
            return this.layout == 'portal' ? window.location.pathname.includes('nettbutikk') ? chainIdFromWebshopUrl : 0 : this.$store.getters['cmsConfigHomepage/getChainId'];
		},
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        chainIdFromWebshopUrl() {
            /**
             * TEMP: Find a better solution.
             * 
             * ChainId always comes after nettbutikk/. Split at nettbutikk/ and return the chainId
             */
            var path = window.location.pathname
            return parseInt(path.slice(path.indexOf('nettbutikk/') + 11).split('/')[0])
        }
	},
    methods: {
        async verifyChangePasswordStep() {
            this.loading = true;
            this.error = ''

            var params = {
                code: this.code,
                // ...(trueCondition && { dogs: "woof" }),
                oldPassword: this.oldPassword,
                password: this.newPassword,
                clientIdentity: this.clientIdentity,
                step: this.currentChangePasswordForm === 'password-verify-email' ? 'verify-email' : this.currentChangePasswordForm
            };

            const res = await service.ChangePassword(process.env.VUE_APP_FIXIT_CORE_API_URL, params);
            if (res.data.responseCode === 200) {
                this.clientIdentity = res.data.clientIdentity
                if (res.data.nextStep) {
                    this.showOTCdialog = true
                    this.currentChangePasswordForm = res.data.nextStep === 'verify-email' ? 'password-verify-email' : res.data.nextStep
                } else {
                    if (res.data.responseCode === 200) {
                        this.showOTCdialog = false
                        this.$forceUpdate();
                        this.toggleEdit();
                        this.$emit('updateUser', new User(res.data.fixitNoUser))
                    }
                }
            } else {
                this.error = res.data.responseMessage
            }
            
            
			this.loading = false;
        },
        async validatePostalCode(){
            const res = await profileSvc.ValidatePostalCode(this.bookingApi, this.modifiedPostalCode);
            if(res.postalCodes.length > 0) {
                this.invalidPostalCode = false
                this.modifiedUser.postalCode = res.postalCodes[0].postalCode;
                this.modifiedUser.postalArea = res.postalCodes[0].city;
            } else {
                this.invalidPostalCode = true
            }
        },
        async updateProfile() {
			this.loading = true;
			this.modifiedUser.profileCreatedTime = this.$moment(this.modifiedUser.profileCreatedTime).format('YYYY-MM-DD');
			this.modifiedUser.profileUpdatedTime = this.$moment(this.modifiedUser.profileUpdatedTime).format('YYYY-MM-DD');
			var user = new User(this.modifiedUser);
			user.mobileNumber = this.modifiedUser.mobileNumber;
			user.userId = this.modifiedUser.userId;
			user.birthDate = this.modifiedUser.birthDate ? this.$moment(this.modifiedUser.birthDate).format('YYYY-MM-DD') : null;
			var params = {
				fixitNoUser: user,
				emailTicket: this.emailTicket,
				mobileTicket: this.mobileTicket,
				clientIdentity: this.clientIdentity
			};
			const userRes = await service.UpdateProfile(process.env.VUE_APP_FIXIT_CORE_API_URL, params);
            /**
             * Response code is only set to 200 once all potential steps have been completed. If 
             * the user has to validate phone number or email, responsecode won't be 200 until this 
             * has been completed.
             */
            if (userRes && userRes.data.responseCode == 200) {
                this.$forceUpdate();
                this.toggleEdit();
                this.$emit('updateUser', new User(userRes.data.fixitNoUser))
            }
            if (userRes.data.validationStatus === 0) {
                if (userRes.data.responseCode === 412) {
                    this.requiredActions = userRes.data.requiredActions
                    this.currentForm = this.requiredActions[0]
                    this.clientIdentity = userRes.data.clientIdentity
                    this.showOTCdialog = true
                }
            }
            
            if (userRes.data.responseCode == 500 && userRes.data.requiredActions && userRes.data.requiredActions.length == 0) {
                this.validationStatusMessage(userRes.data.validationStatus)
            }
            
			this.loading = false;
		},
        async deleteOnlineSluttKunde() {
            if (await profileSvc.DeleteUser(process.env.VUE_APP_FIXIT_NO_BOOKING_URL)) {
                profileSvc.emitSnackbar({
                    message: `Din bruker har blitt slettet! Du blir logget ut om 5 sekunder.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
                setTimeout( () => this.$emit('logout'), 5000);
            } else {
                profileSvc.emitSnackbar({
                    message: `Noe gikk galt når vi prøvde å slette din bruker!`, 
                    visible: true, 
                    duration: 3000, 
                    state: 'error'
                })
            }
        },
        gender(gender) {
            switch(gender) {
                case 0: return 'Kvinne'
                case 1: return 'Mann'
                default: return 'Ikke valgt'
            }
        },
        verifyInputFields() {
            const pattern = /^(?=.*\d)(?=.*[A-Z])[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/
            switch (this.currentChangePasswordForm) {
                case 'reset-password':
                    return !pattern.test(this.newPassword)
                case 'new-password':
                    return !pattern.test(this.newPassword)
                default:
                    return false
            }
        },
        toggleEdit() {
            this.edit = !this.edit
        },
        resetPassword() {
            this.currentChangePasswordForm = 'forgot-password'
            this.verifyChangePasswordStep()
        },
        setPassword(value) {
            this.newPassword = value
        },
        setOldPassword(value) {
            this.oldPassword = value
        },
        setNewPassword(value) {
            this.newPassword = value
        },
        setCode(value) {
            this.code = value
        },
        resetError() {
            this.error = ''
        },
        validationStatusMessage(validationStatus) {
            switch (validationStatus) {
                case 0: break;
                case 1: 
                    this.emailError = true; 
                    this.$refs.eChangeVal.validate()
                    break;
                case 2: 
                    this.mobileError = true; 
                    this.$refs.mChangeVal.validate()
                    break;
                case 3: 
                    this.emailError = true; 
                    this.mobileError = true; 
                    this.$refs.eChangeVal.validate()
                    this.$refs.mChangeVal.validate()
                    break;
            }
        },


        VerifyStep() {
            var body = {
                code: this.code,
                clientIdentity: this.clientIdentity
            }

            if (this.currentForm === 'verify-email') {
                Object.assign(body, { email: this.modifiedUser.email })

                service.VerifyNewEmail(process.env.VUE_APP_FIXIT_CORE_API_URL, body).then(response => {
                    this.error = ''
                    if (response.data.responseCode === 200) {
                        this.emailTicket = response.data.dto
                        this.requiredActions = this.requiredActions.filter(x =>  x !== 'verify-email' )
                        if (this.requiredActions.length != 0) {
                            this.currentForm = this.requiredActions[0]
                        } else {
                            this.showOTCdialog = false
                            this.updateProfile()
                        }
                    } else {
                        this.showResendText = false
                        this.error = response.data.responseMessage
                    }
                })
            }
            if (this.currentForm === 'verify-sms') {
                Object.assign(body, { mobile: this.modifiedUser.mobileNumber })

                service.VerifyNewMobileNumber(process.env.VUE_APP_FIXIT_CORE_API_URL, body).then(response => {
                    this.error = ''
                    if (response.data.responseCode === 200) {
                        this.mobileTicket = response.data.dto
                        this.requiredActions = this.requiredActions.filter(x =>  x !== 'verify-sms')
                        if (this.requiredActions.length != 0) {
                            this.currentForm = this.requiredActions[0]
                        } else {
                            this.showOTCdialog = false
                            this.updateProfile()
                        }
                    } else {
                        this.showResendText = false
                        this.error = response.data.responseMessage
                    }
                })
            }
        },

        async resendCode() {
            this.modifiedUser.profileCreatedTime = this.$moment(this.modifiedUser.profileCreatedTime).format('YYYY-MM-DD');
			this.modifiedUser.profileUpdatedTime = this.$moment(this.modifiedUser.profileUpdatedTime).format('YYYY-MM-DD');
			var user = new User(this.modifiedUser);
			user.mobileNumber = this.modifiedUser.mobileNumber;
			user.userId = this.modifiedUser.userId;
			user.birthDate = this.modifiedUser.birthDate ? this.$moment(this.modifiedUser.birthDate).format('YYYY-MM-DD') : null;
			var params = {
				fixitNoUser: user,
				emailTicket: this.emailTicket,
				mobileTicket: this.mobileTicket,
				clientIdentity: this.clientIdentity,
                resendCode: this.currentForm == 'verify-sms' ? 'sms' : 'email'
			};
            /**
             * Passing resendCode query to update profile triggers a new code to be sent to the user
             */
			const userRes = await service.UpdateProfile(process.env.VUE_APP_FIXIT_CORE_API_URL, params);
            this.error = ''
            this.showResendText = true
        },
        clearStates() {
            if (this.currentChangePasswordForm == 'reset-password') {
                this.$refs.changePass.clearStates()
            }
            this.showResendText = false
            this.showMobileMessage = false
            this.showEmailMessage = false
            this.mobileError = false
            this.emailError = false
            this.currentForm = ''
            this.requiredActions = []
            this.code = ''
            this.error = ''
            this.loading = false
            this.clientIdentity = null
            this.emailTicket = null
            this.mobileTicket = null
            this.currentChangePasswordForm = ''
            this.oldPassword = ''
            this.newPassword = ''
        },
        closeOTCDialog() {
            this.showOTCdialog = false
            this.clearStates()
        },
        async sendGdprSms() {
            this.showGdprDialog = true
            const res = await profileSvc.GetGdprUser(this.bookingApi, {isTpn: this.isTpn ? 'True' : 'False', tpnChainId: this.tpnChainId.toString()});
            if (res) {
                this.gdprRedirectUrl = res.data.gdprUrl
            }
        },
        redirectToGdpr() {
            window.open(this.gdprRedirectUrl, '_blank')
        }
    },
    watch: {
        modifiedUser: {
            handler: {
                deep: true,
                handler(val) {
                    // Compare the original user data to the changed value to determine wether it's been altered.
                    JSON.stringify(this.user) === JSON.stringify(val) ? this.hasChanged = false : this.hasChanged = true;
                }
            },
        },
        modifiedPostalCode: {
            handler: {
                deep: true,
                handler(val) {
                    if(val.length == 4 && val.replace(/\s/g, '').length){
                        this.validatePostalCode();
                    }
                } 
            }
        }
    },
    async created() {
		service = await AppSvc(this.$axios);
        profileSvc = await ProfileSvc(this.$axios);
	},
    beforeDestroy() {
		service = null
        profileSvc = null
	}
}
